var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.8q3.25 0 5.525-2.3Q31.8 26.2 31.8 23q0-3.25-2.3-5.525Q27.2 15.2 24 15.2q-3.25 0-5.525 2.3Q16.2 19.8 16.2 23q0 3.25 2.3 5.525Q20.8 30.8 24 30.8Zm0-2.25q-2.35 0-3.95-1.625T18.45 23q0-2.35 1.625-3.95T24 17.45q2.35 0 3.95 1.625T29.55 23q0 2.35-1.625 3.95T24 28.55ZM24 37q-6.55 0-11.95-3.5-5.4-3.5-8.4-9.35-.15-.2-.2-.5-.05-.3-.05-.65 0-.35.05-.65.05-.3.2-.5 3-5.85 8.4-9.35T24 9q6.55 0 11.95 3.5 5.4 3.5 8.4 9.35.15.2.2.5.05.3.05.65 0 .35-.05.65-.05.3-.2.5-3 5.85-8.4 9.35T24 37Zm0-14Zm0 11.75q5.95 0 10.925-3.2Q39.9 28.35 42.5 23q-2.6-5.35-7.575-8.55-4.975-3.2-10.925-3.2-5.95 0-10.925 3.2Q8.1 17.65 5.45 23q2.65 5.35 7.625 8.55 4.975 3.2 10.925 3.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityOn);
export default __webpack_public_path__ + "static/media/ic_visibility_on.dbc59c25bd8a572cfcae4c9b4f7fa5af.svg";
export { ForwardRef as ReactComponent };